export default __webpack_public_path__ + "static/media/9.f7deb2f0.png";